import { Component, OnInit, ViewChild, ElementRef, NgZone } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ILocation } from './location-modal.interfaces';
import { AlertService } from '../../services/alert.service';

@Component({
  selector: 'app-location-modal',
  templateUrl: './location-modal.component.html',
  styleUrls: ['./location-modal.component.css']
})
export class LocationModalComponent implements OnInit {
  @ViewChild('search', { static: false }) searchElementRef!: ElementRef;
  
  initialLocation: ILocation = {};

  selectedLatitude!: number | null;
  selectedLongitude!: number | null;
  latitude!: number;
  longitude!: number;
  zoom!: number;
  address!: string;
  private geoCoder: any;
  dialog: MatDialogRef<any>;


  constructor(
    private ngZone: NgZone,
    public dialogRef: MatDialogRef<any>,
    public alertService: AlertService
  ) {
    this.dialog = dialogRef;
  }

  ngOnInit() {
    this.geoCoder = new google.maps.Geocoder();
    this.drawInitialLocation();

    const autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement);
    autocomplete.addListener("place_changed", () => {
      this.ngZone.run(() => {
        const place: google.maps.places.PlaceResult = autocomplete.getPlace();
        if (place.geometry && place.geometry.location) {
          this.selectedLatitude = place.geometry.location.lat();
          this.selectedLongitude = place.geometry.location.lng();
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.zoom = 14;
          this.getAddress(this.latitude, this.longitude);
        }
      });
    });
  }

  drawInitialLocation(): void {
    const { address, coordinates } = this.initialLocation;
    const [latitude, longitude] = coordinates || [];
    this.searchElementRef.nativeElement.value = address || '';
    if (address && latitude && longitude) {
      this.latitude = latitude;
      this.longitude = longitude;
      this.selectedLatitude = latitude;
      this.selectedLongitude = longitude;
      this.zoom = 14;
    } else {
      this.setCurrentLocation();
    }
  }

  private setCurrentLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.zoom = 14;
        this.getAddress(position.coords.latitude, position.coords.longitude);
      });
    }
  }

  getAddress(latitude: any, longitude: any) {
    this.geoCoder.geocode({ location: { lat: latitude, lng: longitude } }, (results: any, status: any) => {
      if (status === 'OK' && results[0]) {
        this.address = results[0].formatted_address;
      } else {
        console.error('Geocoder failed due to:', status);
      }
    });
  }

  resetSelection() {
    this.selectedLatitude = null;
    this.selectedLongitude = null;
  }

  onSubmit() {
    this.dialog.close({
      addressSearched: this.searchElementRef.nativeElement.value,
      address: this.address,
      latitude: this.latitude,
      longitude: this.longitude
    });
  }
}